import styled from 'styled-components';

type LabelProps = {
  $disabled: boolean;
};

type CheckmarkProps = {
  $disabled: boolean;
};

/* Customize the label (the container) */
export const Label = styled.label<LabelProps>`
  color: ${(props): string =>
    props.$disabled ? props.theme.radio.state.disabled.labelColor : props.theme.radio.labelColor};
  cursor: ${(props): string => !props.$disabled && 'pointer'};
  display: block;
  font-size: 1rem;
  line-height: 1.25rem; /* line height should be match with Checkmark height */
  margin-bottom: 0.875rem;
  padding-left: 1.75rem;
  position: relative;
  user-select: none;
  width: fit-content;

  /* Hide the browser's default radio button */
  input {
    cursor: pointer;
    height: 0;
    opacity: 0;
    position: absolute;
    width: 0;
  }

  /* On mouse-over, add a grey background color */
  &:hover input ~ span {
    background-color: ${(props): string => !props.$disabled && '#ccc'};
  }

  /* When the radio button is checked, add a blue background */
  & input:checked ~ span {
    align-items: center;
    background-color: ${(props): string =>
      props.$disabled
        ? props.theme.radio.state.disabled.backgroundColor
        : props.theme.radio.state.selected.backgroundColor};
    border: 0.0625px solid
      ${(props): string =>
        props.$disabled ? props.theme.radio.state.disabled.borderColor : props.theme.radio.borderColor};
    display: flex;
    justify-content: center;
  }

  /* Show the indicator (dot/circle) when checked */
  & input:checked ~ span:after {
    display: flex;
  }

  /* Style the indicator (dot/circle) */
  & span:after {
    background: white;
    border-radius: 50%;
    height: 0.625rem;
    width: 0.625rem;
  }
`;

/* Create a custom radio button */
export const Checkmark = styled.span<CheckmarkProps>`
  background-color: ${(props): string => props.theme.radio.backgroundColor};
  border: 0.0625px solid
    ${(props): string =>
      props.$disabled ? props.theme.radio.state.disabled.borderColor : props.theme.radio.borderColor};
  border-radius: 50%;
  height: 1.25rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 1.25rem;

  /* Create the indicator (the dot/circle - hidden when not checked) */
  &:after {
    content: '';
    display: none;
    position: absolute;
  }
`;
